// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-order-history {
  margin-top: 24px;
  padding: 24px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.user-order-history__heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}
.user-order-history__heading h3 {
  margin: 0;
  color: #004195;
  font-size: 18px;
  font-weight: 700;
}
.user-order-history__grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 20px;
}
.user-order-history__loading {
  display: flex;
  justify-content: center;
  padding: 36px;
}
.user-order-history .ant-card {
  border-color: #e2e8f0;
  border-radius: 8px;
}
.user-order-history .ant-card-head {
  min-height: 48px;
  background: #f8fafc;
  border-bottom-color: #e2e8f0;
}

@media (max-width: 600px) {
  .user-order-history {
    padding: 16px;
  }
  .user-order-history__heading {
    align-items: flex-start;
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UserOrderHistory/style.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yCAAA;AACF;AACE;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AACJ;AACI;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACN;AAGE;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AADJ;AAIE;EACE,aAAA;EACA,uBAAA;EACA,aAAA;AAFJ;AAKE;EACE,qBAAA;EACA,kBAAA;AAHJ;AAME;EACE,gBAAA;EACA,mBAAA;EACA,4BAAA;AAJJ;;AAQA;EACE;IACE,aAAA;EALF;EAOE;IACE,uBAAA;IACA,sBAAA;EALJ;AACF","sourcesContent":[".user-order-history {\n  margin-top: 24px;\n  padding: 24px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n\n  &__heading {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 20px;\n\n    h3 {\n      margin: 0;\n      color: #004195;\n      font-size: 18px;\n      font-weight: 700;\n    }\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    gap: 20px;\n  }\n\n  &__loading {\n    display: flex;\n    justify-content: center;\n    padding: 36px;\n  }\n\n  .ant-card {\n    border-color: #e2e8f0;\n    border-radius: 8px;\n  }\n\n  .ant-card-head {\n    min-height: 48px;\n    background: #f8fafc;\n    border-bottom-color: #e2e8f0;\n  }\n}\n\n@media (max-width: 600px) {\n  .user-order-history {\n    padding: 16px;\n\n    &__heading {\n      align-items: flex-start;\n      flex-direction: column;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
